import { useTranslation } from "react-i18next";
import React, { FC } from "react";
import { validationMessegeProps } from "./ValidationMessageProps";

const ValidationMessege: FC<validationMessegeProps> = ({
  className,
  validationMessage,
  validationMessageClass,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`${className} ${validationMessageClass || ""}`}>
      <em>
        {validationMessage.length ? validationMessage : t("notFoundSearch")}
      </em>
    </div>
  );
};

export default ValidationMessege;
